var advance = function() {
  document.querySelectorAll('.grid-meta-color li').forEach((color) => {
    color.addEventListener('mouseover',function(){
      if(color.querySelector('img') != null && color.closest('.snippet-product-grid') != null){
        color.closest('.snippet-product-grid').querySelector('.product-images img').setAttribute('srcset',color.querySelector('img').getAttribute('src'))
      }
    })
    color.addEventListener('mouseout',function(){
      if(color.querySelector('img') != null && color.closest('.snippet-product-grid') != null){
        color.closest('.snippet-product-grid').querySelector('.product-images img').setAttribute('srcset',color.closest('.grid-meta-color').querySelector('li a.active img').getAttribute('src'))
      }
    })
  });
  $th_refreshWishlistItems();
}
var infinitescroll = {
  scolljs: function(){
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      callback: advance,
      offset:1000
    });
  }
}
infinitescroll.scolljs();
document.addEventListener('scroll', function(e) {
  var totalpage = document.querySelector('#AjaxinatePagination a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
  sessionStorage.scrollPos = document.documentElement.scrollTop;
  sessionStorage.totalpage = totalpage;
});
if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
  var scrollTop = sessionStorage?.getItem('scrollPos')
  var buttonTop = document.querySelector('#AjaxinatePagination');
  var buttonScroll = buttonTop.offsetTop - window.scrollY;
  document.documentElement.scrollTop = scrollTop ??  document.body.scrollTop;
  if(buttonScroll < scrollTop){
    var buttonScroll = buttonTop.offsetTop - window.scrollY ;
    scrollManualy(buttonScroll);
  }else{
     scrollManualy(scrollTop);
  }
  function scrollManualy(scrollTop1){
    scrollTop1 = parseInt(scrollTop1);
    window.scrollTo(0,scrollTop1)
    setTimeout(function(){
      if(buttonScroll < scrollTop){
      buttonScroll = buttonTop.offsetTop ;
        scrollManualy(buttonScroll);
      } else {
        window.scrollTo(0,scrollTop)
        return false;
      }
    },500);
  }
}


let filter = document.querySelector("facet-filters-form").offsetTop;
var lastscroll = 0;
window.addEventListener("scroll", () => {
  let scrollcount = window.pageYOffset;
  (scrollcount >= filter) ? document.querySelector('body').classList.add("filter-sticky") : document.querySelector('body').classList.remove("filter-sticky")
  setTimeout(function(){
    if(scrollcount > lastscroll){
      document.querySelector('.snippet-collection-filter').style.top = '0px'
    }else if(scrollcount < lastscroll){
      document.querySelector('.snippet-collection-filter').style.top = document.querySelector('.header-main').clientHeight + 8+'px'
      // console.log(scrollcount,'---',window.pageYOffset,'---',window.outerHeight)
      // document.querySelector('.snippet-collection-filter').style.top = document.querySelector('.snippet-collection-filter').style.top + 8+'px'
      // if(scrollcount >= document.querySelector('.header-main').clientHeight){
      //   document.querySelector('.snippet-collection-filter').style.top = scrollcount + 'px'
      // }
    }
    lastscroll = scrollcount;
  }, 100);
});